import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React, { type ReactElement, type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from '../Modal';
import messages from './messages';

interface IConfirmDialogProps {
  children: ReactNode;
  headerVariant?: 'primary' | 'danger';
  onCancel: (event?: React.MouseEvent) => void;
  onConfirm: () => void;
  open: boolean;
  submitButton?: (onConfirm: () => void) => ReactNode;
  title?: string | ReactElement;
}

const ConfirmDialog = ({
  children,
  headerVariant = 'primary',
  onCancel,
  onConfirm,
  open,
  submitButton = () => null,
  title,
}: IConfirmDialogProps) => (
  <Modal
    actions={
      <>
        <Button color="secondary" onClick={onCancel}>
          <FormattedMessage {...messages.confirmDialogCancelButton} />
        </Button>
        {submitButton(onConfirm) || (
          <Button color="primary" onClick={onConfirm} variant="contained">
            {<FormattedMessage {...messages.confirmDialogConfirmButton} />}
          </Button>
        )}
      </>
    }
    headerVariant={headerVariant}
    maxWidth="xs"
    name="confirm-dialog"
    onClick={(event: React.MouseEvent) => event.stopPropagation()}
    onClose={onCancel}
    open={open}
    title={title}
  >
    <Box>{children}</Box>
  </Modal>
);

export default ConfirmDialog;
